<div class="column footer-container">
	@if (property) {
		<div class="content-container">
			<div class="content-container-header flex-row-end">
				<h3 i18n="@@propety-detailEditingPropertyData" class="flex-grow header-h3">Property Details</h3>
				@if (canEditProperties && (loggedInCompanyIsSentriLock || loggedInCompanyIsPropertyCompany)) {
					@if (this.editPropertyInfo === false) {
						<div>
							<button
								(click)="editButtonClicked()"
								class="primary-small-button"
								data-automation-id="property-about-edit-button"
								i18n="@@property-detailEdit"
							>
								Edit
							</button>
						</div>
					} @else {
						<div>
							<button
								class="secondary-small-button"
								(click)="editButtonCancelClicked()"
								i18n="@@property-detailCancel"
								data-automation-id="property-about-cancel-button"
							>
								Cancel
							</button>
							<button
								(click)="saveEdits()"
								[disabled]="!isValid()"
								class="primary-small-button"
								data-automation-id="property-about-save-changes-button"
								i18n="@@property-detailSave"
							>
								Save Changes
							</button>
						</div>
					}
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				@if (!this.editPropertyInfo) {
					<div class="row">
						<div class="flex-8">
							<div class="row top-bottom-padding">
								<table style="width: 100%">
									<tr class="mat-body-2">
										<td class="width-25-grey" i18n="@@property-detailPropertyName">Property Name</td>
										<td class="width-25-grey" i18n="@@property-detailStatus">Status</td>
										<td class="width-25">&nbsp;</td>
										<td class="width-25">&nbsp;</td>
									</tr>
									<tr class="mat-body-3">
										<td class="table-body-text">{{ this.editProperty.name }}</td>
										<td class="table-body-text">
											<mat-chip-set>
												<mat-chip class="status-chip" [ngClass]="getChipStyling(this.editProperty.active)"
													>&bull;&NonBreakingSpace;{{ displayStatusName(this.editProperty.active) }}</mat-chip
												>
											</mat-chip-set>
										</td>
									</tr>
								</table>
							</div>
							<div class="row top-bottom-padding">
								<table style="width: 100%">
									<tr class="mat-body-3"></tr>
									<tr class="mat-body-2">
										<td class="width-25-grey" i18n="@@property-detailLatitude">Latitude</td>
										<td class="width-25-grey" i18n="@@property-detailLongitude">Longitude</td>
										<td class="width-25-grey" i18n="@@property-detailTimezone">Timezone</td>
										<td class="width-25">&nbsp;</td>
									</tr>
									<tr class="mat-body-3">
										<td class="table-body-text">{{ this.editProperty.latitude }}</td>
										<td class="table-body-text">{{ this.editProperty.longitude }}</td>
										<td class="table-body-text">{{ this.editProperty.timezone }}</td>
									</tr>
								</table>
							</div>
							<div class="row top-bottom-padding">
								<table style="width: 100%">
									<tr class="mat-body-2">
										<td class="width-25-grey" i18n="@@property-detailStreetAddress">Street Address</td>
										<td class="width-25-grey" i18n="@@property-detailApartmentSuite">Apartment/Suite (optional)</td>
										<td class="width-25-grey" i18n="@@property-detailTownCity">Town/City</td>
										<td class="width-25">&nbsp;</td>
									</tr>
									<tr class="mat-body-3">
										<td class="table-body-text">{{ this.editProperty.address1 }}</td>
										<td class="table-body-text">{{ this.editProperty.address2 }}</td>
										<td class="table-body-text">{{ this.editProperty.locality }}</td>
									</tr>
								</table>
							</div>
							<div class="row top-bottom-padding">
								<table style="width: 100%">
									<tr class="mat-body-2">
										<td class="width-25-grey" i18n="@@property-detailStateProvince">State/Province</td>
										<td class="width-25-grey" i18n="@@property-detailPostalCode">Postal Code</td>
										<td class="width-25-grey" i18n="@@property-detailCountry">Country</td>
										<td class="width-25">&nbsp;</td>
									</tr>
									<tr class="mat-body-3">
										<td class="table-body-text">{{ this.editProperty.stateProvinceRegion }}</td>
										<td class="table-body-text">{{ this.editProperty.postalCode }}</td>
										<td class="table-body-text">{{ this.editProperty.country }}</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="flex-1">
							<div style="display: flex; flex-direction: column">
								@if (!isUnitTesting) {
									<app-map [mapCenter]="mapCenter" [markers]="propertyMarker"></app-map>
								}
							</div>
						</div>
					</div>
				} @else {
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutPropertyName">Property Name</mat-label>
							<input
								[disabled]="!(canEditProperties && (loggedInCompanyIsSentriLock || loggedInCompanyIsPropertyCompany))"
								data-automation-id="property-name-input"
								matInput
								[(ngModel)]="editProperty.name"
								maxLength="100"
								required
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutStatus">Status</mat-label>
							<mat-select
								disableOptionCentering
								[(ngModel)]="editProperty.active"
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="status-picker"
							>
								@for (option of activeOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.value">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<div class="column"></div>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color">{{ this.latitudeLabel }}</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="latitude-input"
								matInput
								[(ngModel)]="editProperty.latitude"
								(ngModelChange)="setLatitudeLabel()"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color">{{ this.longitudeLabel }}</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="longitude-input"
								matInput
								[(ngModel)]="editProperty.longitude"
								(ngModelChange)="setLongitudeLabel()"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutTimezone">Timezone</mat-label>
							<input
								[disabled]="true"
								data-automation-id="timezone-input"
								matInput
								[(ngModel)]="editProperty.timezone"
								required
							/>
						</mat-form-field>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutStreet">Street Address</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="address-input"
								matInput
								[(ngModel)]="editProperty.address1"
								maxLength="100"
								(ngModelChange)="onAddressChanged()"
								required
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutApartment">Apartment / Suite</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="apartment-input"
								matInput
								[(ngModel)]="editProperty.address2"
								maxLength="100"
								(ngModelChange)="onAddressChanged()"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutTown">Town / City</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="city-input"
								matInput
								[(ngModel)]="editProperty.locality"
								maxLength="100"
								(ngModelChange)="onAddressChanged()"
								required
							/>
						</mat-form-field>
					</div>
					<div class="row spacing-24">
						<mat-form-field
							subscriptSizing="dynamic"
							class="column"
							[color]="stateFieldOutlineColor"
							appearance="outline"
						>
							<mat-label class="mat-label-color" i18n="@@property-aboutState">State / Province</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="province-input"
								matInput
								[(ngModel)]="editProperty.stateProvinceRegion"
								#stateProvinceRegionFieldModel="ngModel"
								required
								maxLength="100"
								(ngModelChange)="onAddressChanged()"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@property-aboutPostal">Postal Code</mat-label>
							<input
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								data-automation-id="postal-code-input"
								matInput
								[(ngModel)]="editProperty.postalCode"
								maxLength="18"
								(ngModelChange)="onAddressChanged()"
								required
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label
								[ngClass]="!canEditProperties || !this.editPropertyInfo ? 'disabled-color' : 'mat-label-color'"
								i18n="@@property-aboutCountry"
								>Country</mat-label
							>
							<input
								type="text"
								aria-label="Country"
								[disabled]="!canEditProperties || !this.editPropertyInfo"
								[ngClass]="{ 'disabled-color': !canEditProperties || !this.editPropertyInfo }"
								matInput
								required="true"
								[matAutocomplete]="auto"
								[matAutocompleteDisabled]="!canEditProperties || !this.editPropertyInfo"
								name="countryCode"
								[(ngModel)]="editProperty.country"
								(ngModelChange)="filterCountries($event)"
								(click)="openAutocompleteCountries()"
								data-automation-id="country-input"
								(input)="countryInput()"
							/>
							<mat-autocomplete
								#auto="matAutocomplete"
								[displayWith]="displayCountryName"
								(optionSelected)="countrySelected()"
								data-automation-id="country-picker"
							>
								@for (country of filteredCountries | async; track country.twoLetterCode) {
									<mat-option
										[value]="country.twoLetterCode"
										[disabled]="!canEditProperties || !this.editPropertyInfo"
										[attr.data-automation-id]="'country-' + country.twoLetterCode"
									>
										{{ country.name }}
									</mat-option>
								}
							</mat-autocomplete>
							@if (showCountryError) {
								<mat-hint i18n="@@property-aboutCountryError" data-automation-id="country-error">
									Please select a Country from the list
								</mat-hint>
							}
						</mat-form-field>
					</div>
				}
				<mat-divider></mat-divider>
				<div class="row spacing-16 devices-to-be-installed-container">
					<div
						[ngClass]="{ 'disabled-text': !this.editPropertyInfo, 'active-text': this.editPropertyInfo }"
						i18n="@@property-devicesToBeInstalled"
					>
						Devices to be installed:
					</div>
					<div class="row-no-width">
						<button
							mat-stroked-button
							(click)="decrementOnClick()"
							[ngClass]="{
								'incremental-button-disabled': !this.editPropertyInfo,
								'incremental-button': this.editPropertyInfo,
							}"
							[appHasSystemCapability]
							has="deviceManagement"
							[disabled]="!this.editPropertyInfo"
							data-automation-id="property-about-decrement-button"
						>
							-
						</button>
						<input
							[(ngModel)]="this.pendingInstalls"
							[disabled]="true"
							[readonly]="true"
							[ngClass]="{
								'incremental-input-disabled': !this.editPropertyInfo,
								'incremental-input': this.editPropertyInfo,
							}"
							data-automation-id="property-about-pending-installs-input"
						/>
						<button
							mat-stroked-button
							(click)="incrementOnClick()"
							[ngClass]="{
								'incremental-button-disabled': !this.editPropertyInfo,
								'incremental-button': this.editPropertyInfo,
							}"
							[appHasSystemCapability]
							has="deviceManagement"
							[disabled]="!this.editPropertyInfo"
							data-automation-id="property-about-increment-button"
						>
							+
						</button>
					</div>
				</div>
			</div>
		</div>
	}
</div>
